import { notifier } from 'components/Toaster';
import { useMutation } from 'react-query';
import { publicFetch } from 'utilities/fetch';

function useRegisterEmail() {
  async function register(data) {
    return publicFetch.post(`/v1/admin/register/user`, data).then((res) => res.data);
  }

  return useMutation(register, {
    onSuccess() {
      notifier.success('Account request successful');
    },
    onError() {
      notifier.error('Account request was not successful. Please try after some time!');
    },
  });
}

export default useRegisterEmail;
